export namespace Errors {

    export enum Code {
        /**
         * Customer is disabled currently
         */
        CUSTOMER_DISABLED = 1000,
        /**
         * Customer is currently upgrading
         */
        CUSTOMER_MIGRATING = 1001,
    }

}
